import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgInfoFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M0 0h24v24H0z" }),
			/* @__PURE__ */ _jsx("mask", {
				id: "uniqueMaskNameLololol",
				fill: "#fff",
				children: /* @__PURE__ */ _jsx("path", {
					id: "a",
					d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				fill: "#4384f5",
				stroke: "#979797",
				mask: "url(#uniqueMaskNameLololol)",
				children: /* @__PURE__ */ _jsx("path", {
					stroke: "none",
					d: "M0 0h24v24H0z"
				})
			})
		]
	})
});
export default SvgInfoFilled;
